import { useTranslation } from "react-i18next";
import { formatDateAndTime } from "../../../../utils";

const ChangeAddressLog = ({
  createdAt,
  value,
  updatedBy,
}: {
  createdAt: string;
  value?: string;
  updatedBy: string;
}) => {
  const { t } = useTranslation();

  const formatAddress = (address: any) => {
    const formatValue = (value: string | undefined) => {
      if (!value || value === "undefined") return " ";
      return value;
    };

    const {
      companyName,
      addressLine1,
      addressLine2,
      street,
      zipCode,
      city,
      country,
      phone,
    } = address;

    return [
      formatValue(companyName),
      formatValue(addressLine1),
      formatValue(addressLine2),
      formatValue(street),
      zipCode
        ? `${formatValue(zipCode)}, ${formatValue(city)}`
        : formatValue(city),
      formatValue(country),
      formatValue(phone),
    ];
  };

  function tryParseJSON(jsonString?: string): any | null {
    try {
      return jsonString ? JSON.parse(jsonString) : null;
    } catch (e) {
      console.error("Failed to parse JSON", e);
      return null;
    }
  }
  const parsedValue = tryParseJSON(value);
  const { addressType, oldAddress, newAddress } = parsedValue || {};

  return (
    <div className="card-auto p-24 my-10 row row-column gap-8">
      <div> {formatDateAndTime(createdAt, "DD.MM.YYYY HH:mm:ss")}</div>
      <div>
        {updatedBy} {t("changed")}{" "}
        <strong>
          {t(
            addressType === "Billing" ? "Billing Address" : "Shipping Address"
          )}
        </strong>
        <br />
        <br />
        <span>
          {" "}
          <strong>{t("from")}</strong>
        </span>
        <br />
        <br />
        {oldAddress
          ? formatAddress(oldAddress).map((part, idx) => (
              <div key={idx}>{part}</div>
            ))
          : null}
        <br />
        <span>
          {" "}
          <strong>{t("to")}</strong>
        </span>
        <br />
        <br />
        {newAddress
          ? formatAddress(newAddress).map((part, idx) => (
              <div key={idx}>{part}</div>
            ))
          : null}
      </div>
    </div>
  );
};

export default ChangeAddressLog;
